var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket",
    clipPath: "url(#clip0_9893_10747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.588867 11.2078L3.14199 8.69219L7.48887 7.92188L7.05918 10.1969L1.18262 12.0031L0.80293 11.8391L0.588867 11.2078Z",
    fill: "#CA2C31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.58437 9.3376L0.8125 11.8563L2.85156 12.8501L5.94687 11.2704V10.5251L6.57969 8.81885L3.58437 9.3376Z",
    fill: "#A02422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1437 13.7733L8.80459 14.3546L7.54053 17.0343C7.54053 17.0343 8.65303 19.4983 8.70303 19.4983C8.75303 19.4983 9.38584 19.5483 9.38584 19.5483L11.6358 17.0327L12.2046 12.7358L10.1437 13.7733Z",
    fill: "#A02422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.82803 15.7562C8.82803 15.7562 9.57334 15.6046 10.1046 15.3515C10.6358 15.0983 11.2921 14.7202 11.2921 14.7202L11.0515 16.8187L8.6999 19.4952C8.6999 19.4952 8.60771 19.3812 8.21709 18.5312C7.90615 17.853 7.79834 17.6108 7.79834 17.6108L8.82803 15.7562Z",
    fill: "#CA2C31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.93422 12.6029C4.93422 12.6029 4.03734 12.5279 3.05453 13.7701C2.15765 14.9045 1.73734 16.7514 1.57484 17.2264C1.41234 17.7014 1.02328 17.7982 1.15297 18.0154C1.28265 18.2326 1.84359 18.2201 2.53578 18.1342C3.22797 18.0482 3.82172 17.831 3.82172 17.831C3.82172 17.831 3.79203 17.906 3.69203 18.0685C3.65609 18.1264 3.53109 18.2092 3.54047 18.2951C3.56234 18.4998 5.31547 18.5045 6.71547 17.0639C8.22797 15.5092 7.49359 14.2342 7.49359 14.2342L4.93422 12.6029Z",
    fill: "#F7D74D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.20484 13.3267C5.20484 13.3267 4.23765 13.3782 3.43765 14.6204C2.63765 15.8626 2.26577 17.3017 2.34234 17.3985C2.41734 17.4954 3.90796 16.9563 4.26577 17.0642C4.51109 17.1392 4.38452 17.3876 4.45015 17.4532C4.50484 17.5079 5.15171 17.6001 6.19859 16.4657C7.24702 15.3313 6.99859 13.7376 6.99859 13.7376L5.20484 13.3267Z",
    fill: "#FBF0B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.67983 11.6313C5.67983 11.6313 5.19389 12.0642 5.02045 12.3126C4.84702 12.561 4.84702 12.5829 4.85795 12.6579C4.86889 12.7329 5.04858 13.5563 5.79702 14.2782C6.71577 15.1642 7.53608 15.2829 7.65483 15.2829C7.77358 15.2829 8.56264 14.397 8.56264 14.397L5.67983 11.6313Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.82812 14.2563C7.82812 14.2563 8.61563 14.7734 9.93594 14.3297C11.7406 13.7234 13.0641 12.3672 14.7031 10.6547C16.2844 9.00156 17.6109 6.95 17.6109 6.95L16.6813 3.83594L7.82812 14.2563Z",
    fill: "#437687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.6235 12.5515L10.8407 11.8765L11.3845 11.953C11.3845 11.953 11.7985 12.1483 12.1032 12.2905C12.4079 12.4327 12.8001 12.5405 12.8001 12.5405L12.0267 13.1937C12.0267 13.1937 11.6048 13.0343 11.297 12.8999C10.9501 12.7483 10.6235 12.5515 10.6235 12.5515Z",
    fill: "#3F545F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.1752 2.52197C13.1752 2.52197 11.672 3.39385 9.51735 5.43291C7.57516 7.27041 6.1361 8.93291 5.78766 10.347C5.49704 11.5313 5.65173 12.2501 6.31266 13.0267C7.0111 13.8485 7.82985 14.2563 7.82985 14.2563C7.82985 14.2563 8.44548 14.2657 11.0142 12.2892C14.2189 9.82197 16.7861 5.69072 16.7861 5.69072L13.1752 2.52197Z",
    fill: "#8DAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.2782 6.53741C16.2782 6.53741 14.9704 5.9796 14.0376 4.67804C13.111 3.38585 13.1845 2.51241 13.1845 2.51241C13.1845 2.51241 13.9595 1.9046 15.7017 1.20929C16.8735 0.742099 18.4689 0.503037 18.9939 0.892099C19.5189 1.28116 18.6345 3.23272 18.6345 3.23272L17.0235 6.35147L16.2782 6.53741Z",
    fill: "#D83F22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.6517 12.5626C10.6517 12.5626 9.52197 11.986 8.80322 11.1657C7.44385 9.61728 7.1626 7.91728 7.1626 7.91728L7.84541 7.11572C7.84541 7.11572 8.01572 8.92197 9.47354 10.4829C10.4235 11.5001 11.4157 11.9657 11.4157 11.9657C11.4157 11.9657 11.2173 12.1329 11.0048 12.2954C10.8688 12.4001 10.6517 12.5626 10.6517 12.5626Z",
    fill: "#6896A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.6111 6.9501C17.6111 6.9501 18.2893 6.13291 18.9314 4.29072C19.8283 1.72197 19.0471 0.943848 19.0471 0.943848C19.0471 0.943848 18.783 2.16572 17.8658 3.86416C17.1299 5.2251 16.2393 6.52041 16.2393 6.52041C16.2393 6.52041 16.7299 6.74072 16.9955 6.81729C17.3299 6.91416 17.6111 6.9501 17.6111 6.9501Z",
    fill: "#A02422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.22054 10.8844C6.42367 11.0782 6.73148 10.8751 6.93304 10.4001C7.13617 9.92506 7.13304 9.65944 6.97679 9.54694C6.78304 9.40631 6.45804 9.71413 6.31586 9.98756C6.15961 10.2907 6.06742 10.7376 6.22054 10.8844Z",
    fill: "#B3E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.2732 3.14551C13.2732 3.14551 12.0842 4.0002 10.8154 5.1627C9.65135 6.22988 8.87947 7.06426 8.77322 7.25801C8.66072 7.46582 8.65916 7.75957 8.74666 7.90957C8.83416 8.05957 9.02791 8.1377 9.20447 8.00645C9.38104 7.87363 10.6388 6.48301 11.7748 5.48926C12.8138 4.57988 13.6154 4.00332 13.6154 4.00332C13.6154 4.00332 13.9404 3.42832 13.8873 3.29707C13.8342 3.16426 13.2732 3.14551 13.2732 3.14551Z",
    fill: "#B3E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M13.2734 3.1454C13.2734 3.1454 14.1516 2.47196 15.1078 1.99852C15.9969 1.5579 16.8813 1.19071 17.0406 1.50946C17.1922 1.81258 16.2016 2.22508 15.3297 2.78133C14.4578 3.33758 13.6188 4.00165 13.6188 4.00165C13.6188 4.00165 13.4906 3.76727 13.4078 3.55008C13.3156 3.31415 13.2734 3.1454 13.2734 3.1454Z",
    fill: "#ED6A65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.9984 6.13274C13.128 5.33118 11.9171 5.54681 11.3202 6.25931C10.7077 6.99368 10.753 8.11556 11.4765 8.79056C12.1343 9.40306 13.3577 9.54212 14.0952 8.68274C14.7515 7.92024 14.7109 6.78743 13.9984 6.13274Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11.7702 6.54205C11.2531 7.04987 11.2812 8.05612 11.8968 8.51549C12.4343 8.91705 13.1968 8.89674 13.6749 8.40768C14.1531 7.91862 14.1531 7.02955 13.7046 6.57018C13.189 6.04362 12.3624 5.9608 11.7702 6.54205Z",
    fill: "#3F545F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M7.81236 12.0139C7.81236 12.0139 8.77955 11.0327 8.8858 11.1389C8.99205 11.2452 8.97799 11.8405 8.51549 12.503C8.05143 13.1655 7.03111 14.3452 6.2233 15.1405C5.42643 15.9233 4.30299 16.8186 4.19674 16.803C4.11393 16.7905 3.77799 16.6233 3.64361 16.4608C3.51236 16.2998 3.90455 15.5389 4.06236 15.2873C4.22174 15.0358 7.81236 12.0139 7.81236 12.0139Z",
    fill: "#A02524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M3.31723 15.9139C3.30473 16.1389 3.64848 16.4671 3.64848 16.4671L8.88598 11.1405C8.88598 11.1405 8.64067 10.8639 7.91879 11.3124C7.19067 11.7655 6.55316 12.3093 5.61254 13.2202C4.3016 14.4921 3.32973 15.6889 3.31723 15.9139Z",
    fill: "#CA2C31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M2.97813 5.77336C2.80469 5.9468 2.79688 6.22492 2.99063 6.3843C3.16251 6.52649 3.44219 6.4343 3.54688 6.30617C3.65157 6.17805 3.63907 5.89992 3.50001 5.76242C3.36094 5.62336 3.08438 5.66867 2.97813 5.77336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.5,
    d: "M6.40918 5.57044C6.27793 5.71575 6.32011 5.93138 6.44199 6.01107C6.56386 6.09075 6.74668 6.08294 6.83574 5.97357C6.91543 5.87513 6.9248 5.67825 6.80293 5.55638C6.69668 5.45169 6.49355 5.47669 6.40918 5.57044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M8.67948 1.85767C8.67948 1.85767 8.87011 1.31392 8.98261 1.30767C9.09667 1.30142 9.26073 1.85142 9.26073 1.85142C9.26073 1.85142 9.82479 1.85767 9.86229 1.94048C9.91073 2.04673 9.50136 2.40298 9.50136 2.40298C9.50136 2.40298 9.63417 2.93423 9.57167 2.9983C9.50136 3.06861 9.01542 2.78892 9.01542 2.78892C9.01542 2.78892 8.51542 3.13736 8.40761 3.04204C8.31386 2.95923 8.50917 2.39673 8.50917 2.39673C8.50917 2.39673 8.04042 2.05455 8.06542 1.95923C8.10136 1.82486 8.67948 1.85767 8.67948 1.85767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M15.1579 14.8952C15.3469 14.9999 15.5844 14.9405 15.6719 14.7389C15.7516 14.5592 15.6047 14.3452 15.4719 14.2874C15.3391 14.2295 15.1063 14.3061 15.0219 14.4577C14.9391 14.6077 15.0438 14.8327 15.1579 14.8952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M17.8424 10.2875C17.7346 10.1203 17.5018 10.0656 17.3502 10.2C17.2033 10.3313 17.2393 10.5375 17.3221 10.6422C17.4049 10.7469 17.6268 10.786 17.7612 10.7C17.8955 10.6141 17.908 10.3875 17.8424 10.2875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9893_10747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.6f6cf73fbc8c62110ae9bc3c20ce1b79.svg";
export { ForwardRef as ReactComponent };